import { render } from "./FamilyIncomeBenefitPolicyDetails.vue?vue&type=template&id=540d22b5&scoped=true"
import script from "./FamilyIncomeBenefitPolicyDetails.vue?vue&type=script&lang=js"
export * from "./FamilyIncomeBenefitPolicyDetails.vue?vue&type=script&lang=js"

import "./FamilyIncomeBenefitPolicyDetails.vue?vue&type=style&index=0&id=540d22b5&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\ProtectionGuruVue\\client-app\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-540d22b5"]])

export default __exports__